import FsLightbox from "fslightbox-react";
import { useState } from "react";

const KYouthStats = () => {
  const [toggler, setToggler] = useState(false);

  return (
    <div
      id="stats"
      style={{
        scrollMarginBlockStart: 500,
      }}
      className="eduvibe-home-four-about edu-about-area about-style-2 edu-section-gapBottom bg-color-white"
    >
      <div className="container">
        <div className="inner">
          <div
            style={{
              marginTop: 50,
              display: "flex",
              gap: 30,
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <img
              style={{ maxHeight: 400, maxWidth: "50vw" }}
              src={`${process.env.PUBLIC_URL}/k-youth/assets/stats-1.png`}
              alt="stats"
              onClick={() => setToggler(!toggler)}
            />
            <img
              style={{ maxHeight: 400, objectFit: "contain" }}
              src={`${process.env.PUBLIC_URL}/k-youth/assets/stats-2.png`}
              alt="stats"
              onClick={() => setToggler(!toggler)}
            />
          </div>
        </div>
        <FsLightbox
          toggler={toggler}
          sources={[
            `${process.env.PUBLIC_URL}/k-youth/images/new-content/2024-highlights.png`,
          ]}
        />
      </div>
    </div>
  );
};

export default KYouthStats;
